<div class="speech-bubble" [class.opacity]="opacity">
  <app-profile-photo [user]="user" [width]="'35'" [imgBorder]="true"></app-profile-photo>
</div>
